/**
 * HTTP 状态码常量
 */
export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
export const HTTP_NOT_FOUND = 404;
export const HTTP_UNPROCESSABLE_ENTITY = 422;

/** 业务码：IM UserSig 已过期/失效，需重新换签 */
export const BIZ_IM_SIGN_EXPIRED = 70001;
